import React from "react";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { ToolButton } from "../../../../components";
import { hideAlert, showAlert } from "../../../../components/alert/Alert";
import { AlertTypeEnum } from "../../../../enums";
import { IToolButtonProps } from "../../../../interfaces";
import { awardsDataService } from "../../services";
import { asyncify } from "../../../../utilities";
import { UserPermissions } from "../../../../../src/definitions";
import {  securityService } from "../../../../../src/_global/services";

export default function AddButton({ config }: IToolButtonProps) {
  const navigate = useNavigate();
  const { id: moduleId } = config;

  const handleClick = () => {
    const handleYes = async () => {
      hideAlert();
      const { data, success, message }: any = await awardsDataService.create();

      if (success)
        navigate(`/${moduleId}/${data._id}?mode=add`, { replace: true });
      else
        asyncify(() => {
          showAlert({
            content: message,
            options: {
              actions: [{ text: "Okay", onClick: hideAlert, primary: true }],
              type: AlertTypeEnum.Info
            }
          });
        }, 1000);
    };

    showAlert({
      content: "Are you sure you want to add a new award?",
      options: {
        actions: [
          { text: "No", onClick: hideAlert },
          { text: "Yes", onClick: handleYes, primary: true }
        ],
        type: AlertTypeEnum.Question
      }
    });
  };

  return (
    <ToolButton
      text="Add"
      icon={faSquarePlus}
      primary
      raised
      onClick={handleClick}
       invalid={!securityService.checkRoleAccess(UserPermissions.editAwards)}
    />
  );
}
